import { ApolloProvider } from '@trello/graphql';
import React, { Suspense, useState, useCallback } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';
import { LazyPlanSelectionOverlay as PlanSelectionOverlay } from 'app/src/components/FreeTrial/LazyPlanSelectionOverlay';

export const dialogProps = {
  maxWidth: 600,
  displayType: 'board-invite-modal',
};
export const LazyBoardInviteModal: React.FunctionComponent<{
  idBoard: string;
  idOrg?: string;
  onClose: () => void;
}> = ({ idBoard, idOrg = '', onClose }) => {
  const [showPlanOverlay, setShowPlanOverlay] = useState(false);
  const onShowPlanOverlay = useCallback(() => {
    setShowPlanOverlay(true);
  }, []);
  const onHidePlanOverlay = useCallback(() => {
    setShowPlanOverlay(false);
  }, []);

  const BoardInviteModal = useLazyComponent(
    () =>
      import(/* webpackChunkName: "board-invite-modal" */ './BoardInviteModal'),
    { preload: false, namedImport: 'BoardInviteModal' },
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-smoothie',
          feature: 'Board Invite Modal',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <ApolloProvider>
            {showPlanOverlay ? (
              <PlanSelectionOverlay
                orgId={idOrg}
                onClose={onHidePlanOverlay}
                transparentBackground
              />
            ) : (
              <BoardInviteModal
                idBoard={idBoard}
                onClose={onClose}
                onClickUpsell={onShowPlanOverlay}
              />
            )}
          </ApolloProvider>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
};
